import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { TextInput } from "../../styles/Form";
import { Maybe } from "purify-ts/Maybe";
import { RemoteData } from "@nvdb-rapport/shared/src/utils/remoteData";
import { ErrorData } from "../../update/ui";
import { ContractArea } from "../../types";

interface ContractAreaSelectProps {
  contractAreas: RemoteData<ErrorData, ContractArea[]>;
  selectContractArea: React.Dispatch<Maybe<ContractArea>>;
  selectedContractArea: Maybe<ContractArea>;
  isRequired: boolean;
}

export default function ContractAreaSelect({
  selectContractArea,
  contractAreas,
  selectedContractArea,
  isRequired,
}: ContractAreaSelectProps) {
  const handleChange = (_: any, value: ContractArea | null) => {
    selectContractArea(Maybe.fromNullable(value));
  };

  return (
    <Autocomplete
      options={contractAreas.type === "SUCCESS" ? contractAreas.data : []}
      disabled={contractAreas.type !== "SUCCESS"}
      getOptionLabel={option => option.navn}
      noOptionsText="Velg kontraktstype først."
      onChange={handleChange}
      value={selectedContractArea?.extractNullable()}
      loading={contractAreas.type === "LOADING"}
      loadingText="Vennligst vent"
      style={{ width: "100%" }}
      renderInput={params => (
        <TextInput
          {...params}
          id="standard-basic"
          label={isRequired ? "Kontraktsområde*" : "Kontraktsområde"}
          name="kontraktsgrunnlag"
        />
      )}
    />
  );
}
